import { render } from "./ManageLearningCourseLesson.vue?vue&type=template&id=372f7493&lang=pug"
import script from "./ManageLearningCourseLesson.vue?vue&type=script&lang=js"
export * from "./ManageLearningCourseLesson.vue?vue&type=script&lang=js"

import "./ManageLearningCourseLesson.vue?vue&type=style&index=0&id=372f7493&lang=scss"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__